import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Select } from 'antd';

import { ordenarAlfabeticamentPerAtributNom } from '../../commons/ordenacio';
import ObservacioExportacioGraficaContainer from './observacioExportacioGraficaContainer';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';
import {
  MASCARA_YYYYMMDD,
  convertirTextAMomentLocal
} from '../../commons/gestioDates';

const Option = Select.Option;

const calcularLlistatDePeriodes = (estacioSeleccionada, estacions) => {
  if (estacioSeleccionada && estacions[estacioSeleccionada]) {
    return Object.keys(estacions[estacioSeleccionada].periodes);
  } else {
    return [];
  }
};

const calculaPeriodeSeleccionatPerDefecte = (
  estacions,
  estacioSeleccionada,
  periodeSeleccionat,
  periodes
) => {
  // Si el periode de l'estació que teniem anteriorment sel·leccionat encara és al llistat el mantenim
  if (
    periodeSeleccionat !== null &&
    estacions[estacioSeleccionada] &&
    estacions[estacioSeleccionada].periodes[periodeSeleccionat]
  ) {
    return periodeSeleccionat;
  } else {
    // En cas contrari, seleccionem el primer periode del llistat
    if (periodes.length > 0) {
      return periodes[0];
    }
  }
};

class ObservacioExportacioVisualitzacio extends Component {
  constructor(props) {
    super(props);

    this.state = {
      estacionsComArray: [],
      periodesComArray: [],
      periodeSeleccionat: null
    };
  }

  objecteConteDades(objecte) {
    return (
      objecte !== undefined &&
      objecte !== null &&
      Object.keys(objecte).length > 0
    );
  }

  /*
   * Definim que el component té dades que mostrar si hi han estacions i periodes informats
   ***/
  hiHanDades(props) {
    const { estacions, periodes } = props;
    const hiHanEstacions = this.objecteConteDades(estacions);
    const hiHanPeriodes = this.objecteConteDades(periodes);
    return hiHanEstacions && hiHanPeriodes;
  }

  /*
   * Mètode auxiliar que, donat un objecte d'estacions,
   * el transforma en format array amb només el seu id i el seu nom
   ***/
  obtenirArrayDEstacions(estacions) {
    let estacionsComArray = [];
    if (estacions !== undefined && estacions !== null) {
      estacionsComArray = Object.keys(estacions)
        .map(idEstacio => {
          const estacio = estacions[idEstacio];
          return { id: parseInt(idEstacio, 10), nom: estacio.nomEstacio };
        })
        .sort(ordenarAlfabeticamentPerAtributNom);
    }

    return estacionsComArray;
  }

  condicionsFiltratgeSelect(input, option) {
    return (
      option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
    );
  }

  /*
   * En cas de canviar les dades potser el llistat d'estacions haurà canviat.
   * Si l'estació seleccionada ja no hi és al llistat hem d'escollir una nova, un nou periode i un nou llistat de periodes
   ***/
  componentWillReceiveProps(nextProps) {
    const { estacions, estacionsActives } = nextProps;
    const { periodeSeleccionat } = this.state;

    // Valors per defecte
    if (!estacions) return;
    const estacionsComArray = this.obtenirArrayDEstacions(estacionsActives);
    const idNovaEstacioSeleccionada = parseInt(Object.keys(estacions)[0], 10);
    const nouPeriodesComArray = calcularLlistatDePeriodes(
      idNovaEstacioSeleccionada,
      estacions
    );
    const nouPeriodeSeleccionat = calculaPeriodeSeleccionatPerDefecte(
      estacions,
      idNovaEstacioSeleccionada,
      periodeSeleccionat,
      nouPeriodesComArray
    );

    // Actualitzem l'estat del component
    this.setState(previousState => {
      return {
        ...previousState,
        estacionsComArray,
        periodesComArray: nouPeriodesComArray,
        periodeSeleccionat: nouPeriodeSeleccionat
      };
    });
  }

  /*
   * Al canviar d'estació pot ser que el periode seleccionat no estigui present en el llistat de la nova estació.
   * Si és així s'haurà d'escollir el primer periode que hi hagi al llistat
   ***/
  onChangeEstacio(estacioSeleccionada) {
    const dataIniciText = this.props.dataInici;
    const dataFiText = this.props.dataFi;

    const dataInici = convertirTextAMomentLocal(
      dataIniciText,
      MASCARA_YYYYMMDD
    );
    const dataFi = convertirTextAMomentLocal(dataFiText, MASCARA_YYYYMMDD);

    this.props.obtenirObservacionsExportacioPerEstacio(
      dataInici,
      dataFi,
      estacioSeleccionada
    );
  }

  onChangePeriode(periodeSeleccionat) {
    this.setState(previousState => {
      return { ...previousState, periodeSeleccionat };
    });
  }

  // Retorna el llistat d'estacions en format Option d'antd
  renderLlistaDEstacions() {
    const { estacionsComArray } = this.state;

    //Es pot donar el cas que encara no estiguin les estacions carregades.
    if (estacionsComArray.length === 0) return;

    return estacionsComArray.map(estacio => {
      return (
        <Option key={estacio.id} value={estacio.id}>
          {estacio.nom}
        </Option>
      );
    });
  }

  // Retorna el llistat de periodes d'una estació en format Option d'antd
  renderLlistaDePeriodes() {
    const { periodes } = this.props;
    const { periodesComArray } = this.state;

    //Es pot donar el cas que encara no estiguin les estacions carregades.
    if (periodesComArray.length === 0) return;

    return periodesComArray.map(idPeriode => {
      return (
        <Option key={idPeriode} value={idPeriode}>
          {periodes[idPeriode].periode}
        </Option>
      );
    });
  }

  renderSenseDades() {
    if (this.props.dataInici && this.props.dataFi) {
      return (
        <div>
          <div className='observacio-exportacio-visualitzacio'>
            No s'han trobat dades
          </div>
        </div>
      );
    }
    return <div className='observacio-exportacio-visualitzacio' />;
  }

  renderAmbDades() {
    const {
      dataInici,
      dataFi,
      estacions,
      periodes,
      estacioSeleccionada
    } = this.props;
    const { periodeSeleccionat } = this.state;
    const nomEstacio =
      estacioSeleccionada && estacions[estacioSeleccionada]
        ? estacions[estacioSeleccionada].nomEstacio
        : '';
    const nomPeriode =
      periodeSeleccionat && periodes[periodeSeleccionat]
        ? periodes[periodeSeleccionat].periode
        : '';
    const dades =
      nomEstacio && nomPeriode
        ? estacions[estacioSeleccionada].periodes[periodeSeleccionat]
        : {};
    return (
      <div>
        <div className='observacio-exportacio-visualitzacio'>
          {/* Selector de l'estació */}
          <span className='observacio-exportacio-visualitzacio-grup-form'>
            <div className='observacio-exportacio-visualitzacio-etiqueta'>
              Estació:
            </div>
            <Select
              notFoundContent='Estacions no carregades.'
              className='observacio-exportacio-visualitzacio-selector-estacio'
              placeholder='Selecciona estacio'
              showSearch
              value={estacioSeleccionada}
              filterOption={this.condicionsFiltratgeSelect}
              onChange={estacioSeleccionada =>
                this.onChangeEstacio(estacioSeleccionada)
              }
            >
              {this.renderLlistaDEstacions()}
            </Select>
          </span>

          {/* Selector del periode de l'estació */}
          <span className='observacio-exportacio-visualitzacio-grup-form'>
            <div className='observacio-exportacio-visualitzacio-etiqueta'>
              Període:
            </div>
            <Select
              notFoundContent='Periodes no carregats.'
              className='observacio-exportacio-visualitzacio-selector-periode'
              placeholder='Selecciona periode'
              showSearch
              value={periodeSeleccionat}
              filterOption={this.condicionsFiltratgeSelect}
              onChange={periodeSeleccionat =>
                this.onChangePeriode(periodeSeleccionat)
              }
            >
              {this.renderLlistaDePeriodes()}
            </Select>
          </span>

          {/* Gràfica */}
          <ObservacioExportacioGraficaContainer
            nomEstacio={nomEstacio}
            nomPeriode={nomPeriode}
            dades={dades}
            dataInici={dataInici}
            dataFi={dataFi}
            periodeSeleccionat={periodeSeleccionat}
          />
        </div>
      </div>
    );
  }

  render() {
    if (this.hiHanDades(this.props)) {
      return this.renderAmbDades();
    } else {
      return this.renderSenseDades();
    }
  }
}

ObservacioExportacioVisualitzacio.propTypes = {
  dataInici: PropTypes.string,
  dataFi: PropTypes.string,
  estacions: PropTypes.object,
  estacionsActives: PropTypes.object,
  idsEstacionsUsuari: PropTypes.array,
  estacioSeleccionada: PropTypes.number,
  obtenirObservacionsExportacioPerEstacio: PropTypes.func,
  periodes: PropTypes.object
};

export default errorBoundaryWrapper(ObservacioExportacioVisualitzacio);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioExportacioVisualitzacio.js